import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useNavigate, useLocation } from "react-router-dom"
import { Col, Modal, Row, Spin, Typography } from "antd"

import { history } from "../../../data/store/helpers"

import CircularProgressWithLabel from "../CircularProgressWithLabel"

const GlobalInformation = () => {
  const currentPage = useSelector((state) => state.pageDetails.currentPage)
  const pageLoading = useSelector((state) => state.pageDetails.pageLoading)
  const domainConfig = useSelector((state) => state.workspaceSettingsDetails.domainConfig);
  const isWhiteLabeledDashboard = process.env.REACT_APP_WHITE_LABELED_APP === "true";
  const progressPercent = useSelector(
    (state) => state.pageDetails.progressPercent
  )
  const pageLoaderText = useSelector(
    (state) => state.pageDetails.pageLoaderText
  )

  history.navigate = useNavigate()
  history.location = useLocation()

  useEffect(() => {
    var title = "Orimon.ai - No-Code, Sales Enabling, Generative AI bot builder";
    if(isWhiteLabeledDashboard) title = domainConfig?.branding?.organizationLabel || "";
    document.title =
      currentPage || title
  }, [currentPage])

  if (!pageLoading) return false

  return(
    <Modal open centered style={{zIndex: 9999999999}} width={"fit-content"} footer={null} closable={false}>
      <Row gutter={16} style={{paddingInline: "16px"}} align={"middle"} justify={"center"}>
        <Col>
          {progressPercent !== null ? (
            <CircularProgressWithLabel
              value={progressPercent}
              size={40}
              color={'colorSecondary'}
            />
          ) : (
            <Spin/>
          )}
        </Col>

        <Col style={{textAlign: "center"}}>
          <Typography.Title level={4} style={{ margin: 0, maxWidth: 400, textAlign:'center' }} >
            {pageLoaderText.length ? pageLoaderText : "Loading"}...
          </Typography.Title>
        </Col>

      </Row>
    </Modal>
  )
}

export default GlobalInformation
